import TimingDiagramView from 'TimingDiagramView'
import SettingsView from './Settings'

export default function TimingDiagram() {
	return (
		<div className="d-flex">
			<TimingDiagramView />
			<SettingsView />
		</div>
		)
}
